import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';

import { designSystem } from '@/styles/styles';

const SvgComponent = (props: SvgProps) => (
    <Svg width="24" height="24" {...props} viewBox="0 0 24 24" fill="none">
        <Path
            d="M16.6236 16.7824C18.0159 15.3847 18.8765 13.4571 18.8765 11.3284C18.8765 7.06017 15.4164 3.6001 11.1482 3.6001C6.87999 3.6001 3.41992 7.06017 3.41992 11.3284C3.41992 15.5966 6.87999 19.0567 11.1482 19.0567C13.2877 19.0567 15.2242 18.1872 16.6236 16.7824ZM16.6236 16.7824L20.2413 20.4001"
            stroke={props.fill || designSystem.colors.neutral300}
            strokeWidth={1.75}
            strokeLinecap={'round'}
        />
    </Svg>
);
export { SvgComponent as SearchTabIcon };
